import MuiCollapse from '@mui/material/Collapse';
import type { CollapseProps } from '@mui/material/Collapse';

export default function Collapse(props: CollapseProps) {
  return <MuiCollapse {...props} />;
}
